@if (theme$ | async; as theme) {
  <div [ngClass]="theme">
    <div class="border-bottom p-3 d-flex justify-content-between align-items-center">
      <div class="text-primary font-weight-bold">{{ 'NOTIFICATION.DELETE_ALL_MODAL_TITLE' | translate }}</div>
      <lib-button mat-dialog-close faIcon="far fa-times" size="custom" color="primary-link" (buttonClicked)="cancel()"> </lib-button>
    </div>
    <div class="border-bottom p-3 m-3 pb-5">
      <p class="text-primary font-size-small">{{ 'NOTIFICATION.DELETE_ALL_MODAL_BODY' | translate }}</p>
    </div>
    <div class="p-2 d-flex justify-content-end">
      <lib-button [size]="'medium'" class="p-2" [color]="'secondary'" [label]="'BUTTONS.CANCEL' | translate" (click)="cancel()">
      </lib-button>
      <lib-button
        [size]="'medium'"
        class="ml-2 p-2"
        [disabled]="!selectedExportTemplate"
        [label]="'BUTTONS.CONFIRM' | translate"
        (click)="confirmExport()">
      </lib-button>
    </div>
  </div>
}
